export const links = [
	{ to: '/#section_illustration', label: 'Illustration' },
	{ to: '/#section_design', label: 'Design' },
	{ to: '/#section_animation', label: 'Animation' },
	{ to: '/#section_voiceover', label: 'Voiceover' },
	{ to: '/#section_development', label: 'Development' },
];
